export default "__VITE_ASSET__3b026676__"